import { useEffect } from 'react'
import { useLocation } from 'react-router'

import { nativeEventBus } from '~/@common/services/nativeEventBus'

import { useFcmDeviceRegistration } from './useFcmDeviceRegistration'
// import { useFreshpaint } from './useFreshpaint'
import { useNativeBackHandler } from './useNativeBackHandler'
import { useNativeEventBridge } from './useNativeEventBridge'
import { usePopup } from './usePopup'
import { usePushNotificationNavigation } from './usePushNotificationNavigation'
import { useServerMaintenance } from './useServerMaintenance'

const useApp = () => {
  const location = useLocation()

  useNativeEventBridge()
  useNativeBackHandler()
  useFcmDeviceRegistration()
  usePushNotificationNavigation()

  // 모든 네이티브 이벤트 구독이 완료된 후 네이티브에게 준비 완료 신호 전송.
  // ready() 이후 네이티브가 이벤트를 dispatch하므로 구독보다 뒤에 호출해야 한다.
  useEffect(() => {
    nativeEventBus.ready()
  }, [])

  // useFreshpaint()

  useServerMaintenance()

  usePopup()

  return { location }
}

export default useApp
